<div [class.mb-3]="has_mb3" [class.my-3]="has_my3">
  <dk-label [label]="label" [isRequired]="required" [disabled]="disabled || control?.disabled" />

  <form [formGroup]="formGroup" class="row">
    <div class="col-5" style="padding-right: 0">
      <p-select
        [options]="countryCodeList"
        formControlName="_countryCode"
        (onChange)="onCountryCodeChange()"
        id="dialCode"
        optionLabel="searchText"
        filter="true"
        [scrollHeight]="screenHight > 900 ? '200px' : '150px'">
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <div class="d-flex align-items-center gap-2">
            <img
              *ngIf="countryFlags + selectedOption['iso2'] + imageExtension as optionImageSrc"
              [src]="optionImageSrc"
              width="22px"
              height="15px"
              style="border-radius: 3px" />
            <div>{{ selectedOption['dialCode'] }}</div>
          </div>
        </ng-template>
        <ng-template let-option pTemplate="item">
          <div class="d-flex align-items-center gap-1 px-4 dk-option-label">
            <img
              *ngIf="countryFlags + option['iso2'] + imageExtension as optionImageSrc"
              [src]="optionImageSrc"
              width="22px"
              height="15px"
              style="border-radius: 3px" />

            <div class="">{{ option['searchText'] }}</div>
          </div>
        </ng-template>
      </p-select>
    </div>
    <div class="col-7">
      <p-inputMask
        [mask]="mask"
        [id]="controlName"
        [formControlName]="controlName"
        [placeholder]="phoneNumberPlaceholder" />
    </div>
  </form>

  <dk-field-validation-error-message [control]="control" />
</div>
